import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { CSSTransitionGroup } from 'react-transition-group';
import Link from 'react-router/es/Link';

import NameAndImage from './components/addProperty/NameAndImage';
import ImportantDetails from './components/addProperty/ImportantDetails';

import OwnerDetails from './components/addProperty/OwnerDetails';
import PropertyType from './components/addProperty/PropertyType';
import PropertyAddress from './components/addProperty/PropertyAddress';
import PropertyDetails from './components/addProperty/PropertyDetails';
import AncillaryItems from './components/addProperty/AncillaryItems';
import FloorPlans from './components/addProperty/FloorPlans';
import Units from './components/addProperty/Units/Units';
import ContactInformation from './components/addProperty/ContactInformation';
import ServicesAndUtilitiesWizardPage from 'components/landlord_app/applications/components/lease_creator/servicesAndUtilitiesWizardPage';
import Amenities from './components/addProperty/Amenities';
import LeasingAgents from './components/addProperty/LeasingAgents';
import PrescreeningMessage from './components/addProperty/PrescreeningMessage';
import ReviewProperty from './components/ReviewProperty';
import PropertyRooms from './components/addProperty/PropertyRooms';
import FooterButtons from 'components/shared/FooterButtons';

import * as propertiesActions from 'actions/landlordPropertiesActions';
import { reset } from 'redux-form';
import { displayLoader, hideLoader } from 'actions/notificationActions';
import { getTranslatedString } from 'helpers/i18n';

import * as submitValidator from 'helpers/SubmitValidator';

export const PAGES = {
  NAME_AND_IMAGE: 1,
  IMPORTANT_DETAILS: 2,
  OWNER_DETAILS: 3,
  PROPERTY_TYPE: 4,
  PROPERTY_ADDRESS: 5,
  PROPERTY_DETAILS: 6,
  ANCILLARY_ITEMS: 7,
  FLOOR_PLANS: 8,
  UNITS: 9,
  ROOMS: 10,
  CONTACT_INFORMATION: 11,
  SERVICES_AND_UTILITIES: 12,
  LEASING_AGENTS: 13,
  PRESCREENING_MESSAGE: 14,
  REVIEW_PROPERTY: 15,
};

export default connect(
  (store) => ({
    agents: store.landlordProperties.agents,
    add_property: store.form.add_property,
    property: store.landlordProperties.property,
    accounts: store.landlordProperties.accounts,
  }),
  { displayLoader, hideLoader, reset, ...propertiesActions }
)(
  class AddProperty extends Component {
    constructor(props) {
      super(props);
      let page, backToReview;
      if (props.isModeEdit) {
        page = PAGES.REVIEW_PROPERTY;
        backToReview = true;
      } else {
        page = PAGES.NAME_AND_IMAGE;
        backToReview = false;
      }
      this.state = {
        third_party_manager: true,
        page,
        backToReview,
      };
    }

    UNSAFE_componentWillMount() {
      this.props.getAgents();
      this.props.getOwners();
      this.props.hideLoader();
      window.onbeforeunload = function () {
        return false;
      };
    }

    componentWillUnmount() {
      window.onbeforeunload = function () {
        return undefined;
      };
    }

    submitForm = (formData) => {
      this.props.displayLoader('create your property');
      this.props.createProperty(formData);
    };

    nextPage = (formData) => {
      if (this.state.backToReview) {
        this.props.updateProperty(formData, this.props.property);
        this.setState({ page: PAGES.REVIEW_PROPERTY });
      } else if (this.state.page === PAGES.PRESCREENING_MESSAGE) {
        this.submitForm(formData);
      } else if (this.state.page === PAGES.IMPORTANT_DETAILS) {
        // should we show the owner page
        if (formData.third_party_manager === 'false')
          this.setState({
            third_party_manager: false,
            page: this.state.page + 2,
          });
        else
          this.setState({
            third_party_manager: true,
            page: this.state.page + 1,
          });
      } else {
        this.setState({ page: this.state.page + 1 });
      }
    };

    previousPage = () => {
      if (this.state.backToReview) {
        this.props.reset('add_property');
        this.setState({ page: PAGES.REVIEW_PROPERTY });
      } else if (this.state.page === PAGES.NAME_AND_IMAGE) {
        browserHistory.push('/companies/properties');
      } else if (this.state.page === PAGES.PROPERTY_TYPE && !this.state.third_party_manager) {
        this.setState({ page: this.state.page - 2 });
      } else {
        this.setState({ page: this.state.page - 1 });
      }
    };

    goToPage = (page) => {
      this.setState({ page });
      this.refs.mainContainer.scrollTop = 0;
    };

    submitImportantDetails = (formData) => {
      let { account_name, selected_account } = formData;
      let account_id = selected_account ? selected_account.value : undefined;

      let result = submitValidator.assignBankAccountToProperty(
        account_name,
        account_id,
        this.props.accounts
      );
      if (result) {
        this.nextPage(formData);
      }
    };

    render() {
      const { page } = this.state;

      const pageTitle =
        this.props.isModeEdit && this.props.property ? this.props.property.name : 'Add Property';
      const nextbuttonLabel = this.props.isModeEdit
        ? getTranslatedString('save')
        : getTranslatedString('next');
      return (
        <div className="body" role="main" ref="mainContainer">
          <div>
            <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
              <span className="page-title">
                <Link id="maintenanceHeader" style={{ color: 'inherit' }} to="companies/properties">
                  Properties
                </Link>{' '}
                >{' '}
              </span>
              <span className="page-title">{pageTitle}</span>

              {this._renderPropertyCreatedExternallyMessage()}

              <div className="container" style={{ maxWidth: '600px', padding: '0px' }}>
                <CSSTransitionGroup
                  transitionName="fade_out"
                  transitionEnterTimeout={200}
                  transitionAppear={true}
                  transitionAppearTimeout={500}
                  transitionLeaveTimeout={200}
                >
                  {page === PAGES.NAME_AND_IMAGE && <NameAndImage onSubmit={this.nextPage} />}
                  {page === PAGES.IMPORTANT_DETAILS && (
                    <ImportantDetails
                      onSubmit={this.submitImportantDetails}
                      accounts={this.props.accounts}
                    />
                  )}
                  {page === PAGES.OWNER_DETAILS && <OwnerDetails onSubmit={this.nextPage} />}
                  {page === PAGES.PROPERTY_TYPE && <PropertyType onSubmit={this.nextPage} />}
                  {page === PAGES.PROPERTY_ADDRESS && <PropertyAddress onSubmit={this.nextPage} />}
                  {page === PAGES.PROPERTY_DETAILS && <PropertyDetails onSubmit={this.nextPage} />}
                  {page === PAGES.ANCILLARY_ITEMS && <AncillaryItems onSubmit={this.nextPage} />}
                  {page === PAGES.FLOOR_PLANS && <FloorPlans onSubmit={this.nextPage} />}
                  {page === PAGES.UNITS && <Units onSubmit={this.nextPage} />}
                  {page === PAGES.ROOMS && <PropertyRooms onSubmit={this.nextPage} />}
                  {page === PAGES.CONTACT_INFORMATION && (
                    <ContactInformation onSubmit={this.nextPage} />
                  )}
                  {page === PAGES.AMENITIES && <Amenities onSubmit={this.nextPage} />}
                  {page === PAGES.LEASING_AGENTS && (
                    <LeasingAgents onSubmit={this.nextPage} agents={this.props.agents} />
                  )}
                  {page === PAGES.SERVICES_AND_UTILITIES && (
                    <ServicesAndUtilitiesWizardPage
                      form={'add_property'}
                      onSubmit={this.nextPage}
                      isReviewMode={false}
                    />
                  )}
                  {page === PAGES.PRESCREENING_MESSAGE && (
                    <PrescreeningMessage onSubmit={this.nextPage} />
                  )}
                  {page === PAGES.REVIEW_PROPERTY && (
                    <ReviewProperty onSubmit={this.nextPage} goToPage={this.goToPage} />
                  )}
                  <div style={{ height: '300px' }} />
                </CSSTransitionGroup>
              </div>
            </div>
          </div>
          {!(this.props.isModeEdit && page === PAGES.REVIEW_PROPERTY) && (
            <FooterButtons
              submit={this.nextPage}
              backAction={this.previousPage}
              formName="add_property"
              submitName={nextbuttonLabel}
              showUnsavedChangesIndicator={true}
            />
          )}
        </div>
      );
    }

    _renderPropertyCreatedExternallyMessage = () => {
      if (!this.props.isModeEdit) return;
      if (!this.props.property) return;
      if (this.props.property.editable === 'true') return;

      return (
        <p style={{ textAlign: 'justify' }}>
          <i className="em em-warning" />
          <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>IMPORTANT</b>
          <i className="em em-warning" /> This property was created through an external service.
        </p>
      );
    };
  }
);
